<template>
    <v-card class="mx-auto" shaped elevation="7">
        <v-card-title>
            Contratante
            <v-spacer></v-spacer>
            <v-btn rounded dark color="primary" @click="dialogForm = true">Nuevo</v-btn>

            <ModalContratante :seleccionado="seleccionado" :tituloFormulario="tituloFormulario"
                              :listaGeneral="listaGeneral" :listaEstado="listaEstadoModal"
                              :listaTipoPersona="listaTipoPersonaModal" :carga="dialogForm"/>
                              

        </v-card-title>
        <v-card-text>
            <v-container fluid grid-list-sm>
                <v-row dense>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="tipoPersonaFiltro" :items="listaTipoPersonaModal"
                            item-text="tipoPersona" color="textbox" item-value="idTipoPersona" label="Tipo Persona"
                            @change="listar()" outlined dense></v-autocomplete>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-autocomplete v-model="estadoFiltro" :items="listaGeneral.estado" color="textbox"
                            item-text="nombre_estado" item-value="id_estado" label="Estado" @change="listar()" outlined
                            dense>
                        </v-autocomplete>
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12" sm="6" />
                    <v-col cols="12" sm="6">
                        <v-text-field label="Buscar" color="textbox" v-model="buscar" clearable dense
                            prepend-inner-icon="search" />
                    </v-col>
                </v-row>
                <v-row dense>
                    <v-col cols="12">
                        <v-data-table :headers="listaGeneral.cabecera" :items="listaGeneral.detalle" :search="buscar"
                            class="elevation-3">

                            <template v-slot:item.nombres="{ item }">
                                {{ item.nombreCompleto }}
                            </template>

                            <template v-slot:item.name="{ item }">
                                <v-btn class="ma-2" text icon color="primary" @click="editarItem(item)">
                                    <v-icon small>edit</v-icon>
                                </v-btn>
                            </template>

                            <template v-slot:no-results>
                                Tu búsqueda de "<span v-html="buscar"></span>" no arrojó resultados.
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name:'ContratanteView',
        components:{
            ModalContratante: () => import('@/components/catalogo/ModalContratanteComponent.vue')
        },
        data: () => ({
            ProgressBar: true,
            buscar: '',
            dialogForm: false,
            seleccionado: {},
            //Listas
            listaGeneral: {},
            //Filtros
            tipoPersonaFiltro: null,
            estadoFiltro: null,
        }),
        watch: {
            listaGeneral() {
                this.tipoPersonaFiltro = this.listaTipoPersonaModal[0].idTipoPersona;
                this.listar();
            }
        },
        computed: {
            tituloFormulario() {
                return (this.seleccionado.idContratante == "0" || this.seleccionado.idContratante == null) ? 'Nuevo Contratante' : 'Editar Contratante';
            },
            listaEstadoModal() {
                this.seleccionado.idEstado = _.isNull(this.seleccionado.idContratante) ? '1' : this.seleccionado.idEstado;
                var listadoEstadoModal = _.get(this.listaGeneral,'estado',[]);

                return _.filter(listadoEstadoModal,{'visualiza':'true'});
            },
            listaTipoPersonaModal() {
                var listaTipoPersonaModal = _.get(this.listaGeneral,'tipoPersona',[]);

                return _.filter(listaTipoPersonaModal,{'visualiza':'true'});
            }
        },
        created(){
            this.cargaGeneral();
        },
        methods: {
            submit() {
                this.$validator.validateAll()
            },
            cargaGeneral() {
                axios.post(`${BASE_URI}administrador/contratante/cargaGeneral`, { opcion: 'L' })
                     .then((r) => {
                        if (r.status != '200' || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            this.$set(this,'listaGeneral',r.data.data);
                            this.listaGeneral.cabecera.push({ text: "Acción", value: 'name' });
                            this.estadoFiltro = this.listaGeneral.estado[0].id_estado;
                     })
                     .catch(function (er) {
                         mensajesAlerta(er, "E");
                     });
            },
            editarItem(item) {
                this.seleccionado = Object.assign({}, item),
                this.dialogForm = true
            },
            cerrarFormulario() {
                this.dialogForm = false
                this.seleccionado = {}
            },
            listar() {
                this.listaGeneral.detalle = [];
                var error = 'E';
                var objeto = {
                    opcion: 'L',
                    idTipoPersona: this.tipoPersonaFiltro,
                    idEstado: this.estadoFiltro
                };

                axios.post(`${BASE_URI}administrador/contratante/listar`, objeto)
                     .then((r) => {
                        if (r.status != '200' || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                        if (_.size(_.get(r,['data','data','detalle'],[])) == 0) { error = 'I'; throw _.get(r,['data','mensaje'],mensajeEstandar.errorPeticion); }
                            this.listaGeneral.detalle = r.data.data.detalle;
                            this.listaGeneral.cabecera = r.data.data.cabecera;
                            this.listaGeneral.cabecera.push({  text: "Acción", value: 'name' });
                     })
                     .catch(function (er) {
                        mensajesAlerta(mensajeEstandar.errorInesperado, error);
                     });
            },

            insertarActualizar(_opcion) {
                axios.post(`${BASE_URI}administrador/contratante/insertarActualizar`, { opcion: _opcion, poliza: this.seleccionado })
                     .then((r) => {
                        if (r.status != '200' || r.statusText != 'OK') throw mensajeEstandar.errorPeticion;
                        if (_.get(r,['data','existeError'],true)) throw mensajeEstandar.errorPeticion;
                            this.listar();
                            mensajeAlertaTiempo(r.data.mensaje, 'S');
                     })
                     .catch(function (er) {
                         mensajesAlerta(er, "E");
                     });
            }
        },
        provide() {
            return {
                insertarActualizar: this.insertarActualizar,
                cerrarFormulario: this.cerrarFormulario
            }
        },
    }
</script>